<div class="appointment-modal">
  <button type="button" class="btn-close" (click)="dialogRef.close()" aria-label="Close dialog">
    <fa-icon [icon]="faClose"></fa-icon>
  </button>
  
  <div class="modal-header">
    <h3>Book an Appointment</h3>
    <p>Fill out the details below to request a booking from <strong>{{data.business.Name}}</strong>.</p>
  </div>
  
  <form [formGroup]="bookingForm" (submit)="makeAppointment()" class="modal-form">
    <div class="form-row">
      <div class="form-group col-md-6">
        <label for="appointmentDate">Appointment Date</label>
        <input 
          id="appointmentDate" 
          type="date" 
          formControlName="appointmentDate" 
          [min]="minDateString"
          class="form-control-custom"
        >
        <span class="error-msg" *ngIf="bookingForm.controls.appointmentDate.touched && bookingForm.controls.appointmentDate.invalid">
          Date is required
        </span>
      </div>
      
      <div class="form-group col-md-6">
        <label for="appointmentStart">Preferred Start Time</label>
        <input 
          id="appointmentStart" 
          type="time" 
          formControlName="appointmentStart"
          class="form-control-custom"
        >
        <span class="error-msg" *ngIf="bookingForm.controls.appointmentStart.touched && bookingForm.controls.appointmentStart.invalid">
          Time is required
        </span>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-6">
        <label for="clientName">First Name</label>
        <input 
          id="clientName" 
          type="text" 
          placeholder="First Name" 
          formControlName="clientName"
          class="form-control-custom"
        >
        <span class="error-msg" *ngIf="bookingForm.controls.clientName.touched && bookingForm.controls.clientName.invalid">
          First name is required
        </span>
      </div>
      
      <div class="form-group col-md-6">
        <label for="clientSurname">Surname</label>
        <input 
          id="clientSurname" 
          type="text" 
          placeholder="Surname" 
          formControlName="clientSurname"
          class="form-control-custom"
        >
        <span class="error-msg" *ngIf="bookingForm.controls.clientSurname.touched && bookingForm.controls.clientSurname.invalid">
          Surname is required
        </span>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-6">
        <label for="clientMobile">Mobile Number</label>
        <input 
          id="clientMobile" 
          type="tel" 
          placeholder="e.g. 082 123 4567" 
          formControlName="clientMobile"
          class="form-control-custom"
        >
        <span class="error-msg" *ngIf="bookingForm.controls.clientMobile.touched && bookingForm.controls.clientMobile.invalid">
          Mobile is required
        </span>
      </div>
      
      <div class="form-group col-md-6">
        <label for="clientEmail">Email Address</label>
        <input 
          id="clientEmail" 
          type="email" 
          placeholder="e.g. email@domain.com" 
          formControlName="clientEmail"
          class="form-control-custom"
        >
        <span class="error-msg" *ngIf="bookingForm.controls.clientEmail.touched && bookingForm.controls.clientEmail.invalid">
          Valid email is required
        </span>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-12">
        <label for="additionalNotes">Additional Notes (Optional)</label>
        <textarea 
          id="additionalNotes" 
          placeholder="Let us know any specific requests or instructions..." 
          formControlName="additionalNotes"
          class="form-control-custom textarea-custom"
          rows="3"
        ></textarea>
      </div>
    </div>

    <div class="form-actions">
      <button 
        type="button" 
        class="btn-cancel" 
        (click)="dialogRef.close()"
      >
        Cancel
      </button>
      <button 
        type="submit" 
        class="btn-submit" 
        [disabled]="bookingForm.invalid || makingAppointment"
      >
        Submit
      </button>
    </div>
  </form>
</div>